<p-dialog
  header="Access"
  [showHeader]="true"
  [(visible)]="displayBasic"
  [modal]="true"
  [style]="{ width: '30vw' }"
  [baseZIndex]="2045"
  (onHide)="onCloseDialog()">
  <div class="mt-3">
    <div class="access-denied-wrap">
      <div class="access-denied-img">
        <img [src]="images?.access_denied" alt="" />
      </div>
      <div class="access-denied-content">
        <h3>Access Denied</h3>
        <p class="my-3">You do not have permission to access this page, please contact your administrator.</p>
        <a [routerLink]="['/']" routerLinkActive="router-link-active" class="btn btn-outline-primary box-shadow-none">Go to Dashboard</a>
      </div>
    </div>
  </div>
</p-dialog>
